import { useState, useEffect } from 'react';
import {
  Box,
  Fade,
  Typography,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import PacmanLoader from 'react-spinners/PacmanLoader';
import VizzleLogo from '../../../vizzle_NoTag.svg';
import { loginWithOidc } from '../../../services/LoginService';
import { usePrepareData } from '../LoginHooks';

const loadingMessage = 'Loading, please wait';
const errorMessage = 'An error occurred. Please contact your admin.';
const REDIRECT_PREFIX = 'redirectTo=';

/**
 * Read the authorization code and the post-login target out of the OIDC callback fragment.
 *
 * Rethink returns `#state=redirectTo%3d%2flesson%2f<uuid>&code=...&id_token=...`, where the
 * state we sent (`redirectTo=<path>`) comes back URL-encoded. Parsing with URLSearchParams
 * decodes every escaped character, so a target carrying a query string such as
 * `/topic-plan/3195?level=2` survives, and the order of the fragment parameters no longer matters.
 * A bare `redirectTo=<path>` parameter is accepted too.
 */
export const parseOidcCallbackFragment = (hash) => {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const authorizationCode = params.get('code');
  let redirectTo = null;
  const state = params.get('state');
  if (state && state.startsWith(REDIRECT_PREFIX)) {
    redirectTo = state.slice(REDIRECT_PREFIX.length);
  } else if (params.get('redirectTo')) {
    redirectTo = params.get('redirectTo');
  }
  return { authorizationCode, redirectTo: redirectTo || null };
};

export default function LoginRethinkSignInOidc() {
  const [showError, setShowError] = useState(false);
  const { hash } = useLocation();
  const {
    prepareData,
  } = usePrepareData();

  useEffect(() => {
    const login = async () => {
      const { authorizationCode, redirectTo } = parseOidcCallbackFragment(hash);
      if (authorizationCode) {
        const result = await loginWithOidc(authorizationCode);
        prepareData(result, redirectTo);
      } else {
        setShowError(true);
      }
    };

    login();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box display='flex' flexDirection='column' width='100vw' height='100vh'>
      <Box mx='auto' mt='120px'>
        <img src={VizzleLogo} alt='Vizzle Logo' width='250px' />
      </Box>
      {showError ? (
        <Fade timeout={1500} in>
          <Box display='flex' flexDirection='column' mt='80px' mx='auto'>
            <Typography variant='h5' gutterBottom>
              {errorMessage}
            </Typography>
          </Box>
        </Fade>
      ) : (
        <Box mt='50px' mx='auto'>
          <Box width='100px' height='100px' mx='auto'>
            <PacmanLoader size={50} color='#3b94d1' css={{ margin: 'auto' }} />
          </Box>
          <Box mt='20px'>
            <Typography variant='h5' gutterBottom>
              {loadingMessage}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}
